import { createFileRoute, redirect } from '@tanstack/react-router'

import type { AuthStatus } from '@graphit/types'

import { authQueryOptions } from '~/queries/auth'

export const Route = createFileRoute('/_unauthed')({
	beforeLoad: ({ context }) => {
		const auth = context.queryClient.getQueryData<AuthStatus>(authQueryOptions.queryKey)
		if (auth?.authenticated) {
			throw redirect({ to: '/' })
		}
	}
})
